module.exports = __webpack_public_path__ + "static/media/trackDark.11b5da62.svg";